
module.provider('BasicOptions', function(LabeledArray) {
    this.$get = function() {
        var i, commonAges = [], allAges = [];
        for (i = 14; i <= 30; i++) { allAges.push([i.toString(), i.toString()]); }
        for (i = 16; i <= 24; i++) { commonAges.push([i.toString(), i.toString()]); }

        return {
            'commonAges': new LabeledArray(commonAges),
            'allAges': new LabeledArray(allAges),
            'boolean': new LabeledArray([
                [true, 'Yes'],
                [false, 'No'],
            ]),
            'booleanString': new LabeledArray([
                ['true', 'Yes'],
                ['false', 'No'],
            ]),
            'yesNoUnknown': new LabeledArray([
                ["yes", 'Yes'],
                ["no", 'No'],
                ['unknown', 'Unknown']
            ]),
            'unknown': new LabeledArray([
                ["yes", 'Yes'],
                ["no", 'No'],
                ['unknown', 'Unknown']
            ]),
            'amcHourTypes': new LabeledArray([
                ['ft', 'Full Time'],
                ['ht', 'Half Time'],
                ['rht', 'Reduced Half Time'],
                ['qt', 'Quarter Time'],
                ['mt', 'Minimum Time'],
                ['htm', 'Youth Opportunity Mentor Team Leader'],
                ['mtm', 'Youth Opportunity Mentor'],
            ])
        };
    };
});

module.provider('StateList', function() {

    this.$get = function(ModelConfig) {
        return function() {
            return ModelConfig.getUsStates(true)
        };
    };
});